export default "__VITE_ASSET__BQ$gkzIQ__"